import { render, staticRenderFns } from "./menumange.vue?vue&type=template&id=7b8e5f8a&scoped=true"
import script from "./menumange.vue?vue&type=script&lang=js"
export * from "./menumange.vue?vue&type=script&lang=js"
import style0 from "./menumange.vue?vue&type=style&index=0&id=7b8e5f8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8e5f8a",
  null
  
)

export default component.exports